export default [
  {
    name: 'confirmation',
    path: '/confirmation',
    component: () => import(/* webpackChunkName: "event" */ './pages/Confirmation.vue'),
    meta: {
      roles: []
    }
  }
]
